export default "__VITE_ASSET__eb96a796__"